module.exports = __webpack_public_path__ + "static/media/abhranilbhattacharjee.4738218c.jpeg";